export function Loading({ label = 'Loading...' }: { label?: string }): JSX.Element {
  return (
    <div className="loading" role="status" aria-live="polite" data-testid="loading">
      <div className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export function EmptyState({ label }: { label: string }): JSX.Element {
  return (
    <div className="empty-state" role="status" data-testid="empty-state">
      {label}
    </div>
  );
}
